<template>
    <div class="ppv2-py-3">
        <!-- Bloc d'acompte -->
        <div class="d-flex ppv2-flex-col md:ppv2-flex-row" :style="{ gap: normalizeSize(56) }">
            <!-- Type d'acompte -->
            <div class="md:ppv2-w-1/2 ppv2-w-full">
                <BaseSelect
                    :label="$t('experience.step5.demandeAcompte.titleSelect')"
                    :customSizeLabel="11"
                    class="ppv2-text-black"
                    v-model="type"
                    @input="clearError()"
                    :state="getState()"
                    :options="option_accompte"
                    :searchable="false"
                    option-label="label"
                    option-value="value"
                    :placeholder="$t('common.placeholderSelect')"
                />
                <!-- Message d’erreur -->
                <p v-if="errors.type" class="ppv2-text-sm ppv2-mt-1" style="color: #ed4b9e">{{ errors.type }}</p>
            </div>

            <!-- Valeur d'acompte -->
            <div class="md:ppv2-w-1/2 ppv2-w-full" v-if="type">
                <CustomInput
                    v-model="acompteValue"
                    type="number"
                    placeholder="Ex. 30"
                    :label="labelAcompte"
                    @input="clearError()"
                    :state="getState()"
                    :right-icon="unit"
                    :customSizeLabel="11"
                    classContainerAdd="!ppv2-opacity-100 !ppv2-mb-0 gap-2"
                    classInputAdd="!ppv2-max-w-[200px] !ppv2-w-full"
                    customClassLabel="poppinsMedium"
                />
                <p v-if="errors.acompteValue" class="ppv2-text-sm ppv2-mt-1" style="color: #ed4b9e">{{ errors.acompteValue }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import BaseSelect from '../../../Shared/BaseSelect.vue'
import BaseInput from '../../../Shared/BaseInput.vue'
import CustomInput from '../../../Inputs/CustomInput.vue'
import normalizeSize from '../../../../utils/normalizeSize'

export default {
    name: 'AcompteForm',
    components: { CustomInput, BaseSelect, BaseInput },
    props: {
        value: {
            type: Object,
            default: () => ({ type: null, value: null }),
        },
        price: {
            type: [Number, String],
            default: 0,
        },
    },
    data() {
        return {
            option_accompte: [
                { label: this.$t('experience.step5.demandeAcompte.optionPercent'), value: 'percentage' },
                {
                    label: this.$t('experience.step5.demandeAcompte.optionAmount', { symbol: this.$symbolCurrency }),
                    value: 'amount',
                },
            ],
            errors: {},
        }
    },
    computed: {
        type: {
            get() {
                return this.value.type
            },
            set(val) {
                this.$emit('input', { ...this.value, type: val })
            },
        },
        acompteValue: {
            get() {
                return this.value.value
            },
            set(val) {
                this.$emit('input', { ...this.value, value: val })
            },
        },
        labelAcompte() {
            return this.type === 'amount'
                ? this.$t('experience.step5.demandeAcompte.amountAcompte')
                : this.$t('experience.step5.demandeAcompte.percentAcompte')
        },
        unit() {
            return this.type === 'amount' ? this.$symbolCurrency : '%'
        },
    },
    methods: {
        normalizeSize,
        getState() {
            if (this.errors.acompteValue) return 'error'
            if (this.acompteValue) return 'valid'
            return 'default'
        },
        clearError() {
            if (this.errors.acompteValue) {
                this.errors.acompteValue = ''
            }
        },
        validate() {
            const errors = {}

            if (!this.type || this.type === '') {
                errors.type = this.$t('experience.errors.requiredAcompteType')
            }
            if (this.acompteValue === null || this.acompteValue === '' || this.acompteValue < 0) {
                errors.acompteValue = this.$t('experience.errors.requiredAmount')
            } else if (this.type === 'percentage' && (this.acompteValue < 0 || this.acompteValue > 100)) {
                errors.acompteValue = this.$t('experience.errors.percentageRange')
            }

            this.errors = errors
            console.log(this.errors)

            // ✅ Et on émet aussi les erreurs si le parent veut les écouter
            this.$emit('validation', errors)

            return Object.keys(errors).length === 0
        },
    },
}
</script>

<style scoped></style>
